<template>
  <van-row :class="['express-item', active ? 'active' : ''].join(' ')">
    <van-col span="3">
      <div class="icon-wrap">
        <div class="iconfont">{{statusConf.icon}}</div>
      </div>
    </van-col>
    <van-col class="context" span="21">
      <div class="title">{{statusConf.title}}</div>
      <div class="text" v-html="stationHtml"></div>
      <div class="time">{{express.acceptTime}}</div>
    </van-col>
  </van-row>
</template>

<script>
import {
  Row,
  Col
} from 'vant'

import {
  EXPRESS_STATUS
} from '@assets/config'

export default {
  props: {
    express: {
      type: Object
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    status: undefined,
    statusConf: {
      title: '',
      value: undefined,
      icon: ''
    }
  }),
  computed: {
    stationHtml () {
      const reg = /1[3|4|5|6|7|8|9][0-9]{9}/
      const oldAcceptStation = this.express.acceptStation
      const regRes = reg.exec(oldAcceptStation)
      if (regRes) {
        const newAcceptStation = oldAcceptStation.replace(regRes[0], `<a style="color: #4573DE" href="tel:${regRes[0]}">${regRes[0]}</a>`)
        return newAcceptStation
      } else {
        return oldAcceptStation
      }
    }
  },
  mounted () {
    if (this.express.acceptStation.indexOf('已收取') >= 0 || this.express.acceptStation.indexOf('等待揽收') >= 0 || this.express.acceptStation.indexOf('已收件') >= 0) {
      this.status = 4
    } else if (this.express.acceptStation.indexOf('已揽收') >= 0 || this.express.acceptStation.indexOf('已收取') >= 0) {
      this.status = 3
    } else if (this.express.acceptStation.indexOf('正在派') >= 0) {
      this.status = 1
    } else if (this.express.acceptStation.indexOf('签收') >= 0 || this.express.acceptStation.indexOf('取件') >= 0) {
      this.status = 0
    } else {
      this.status = 2
    }
    this.statusConf = this.renderStatus(this.status)
  },
  methods: {
    renderStatus (text) {
      return (!text && text !== 0) ? null : ((EXPRESS_STATUS || []).find(t => t.value === text) ? (EXPRESS_STATUS || []).find(t => t.value === text) : text)
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
